import {createSelector} from "reselect";
import {getOrpyxUsersState} from "../../store/orpyx-users-store-selectors";

export const getOrpyxUserRevokeRoleState = createSelector(getOrpyxUsersState, state => state.revokeUserRole);
export const getOrpyxUserRevokeRoleError = createSelector(getOrpyxUserRevokeRoleState, state => state.error);
export const getOrpyxUserRevokeRoleModel = createSelector(getOrpyxUserRevokeRoleState, state => state.userRole);
export const getOrpyxUserRevokeRoleUserId = createSelector(getOrpyxUserRevokeRoleState, state => state.userId);
export const isOrpyxUserRevokeRoleModalActive = createSelector(getOrpyxUserRevokeRoleState, state => state.toggleModal);
export const isOrpyxUserRevokeRoleInProcess = createSelector(getOrpyxUserRevokeRoleState, state => state.inProcess);
